
import { defineComponent, ref, PropType, SetupContext, computed } from "vue";
import NativeClient, { TitleInfo } from "@/client/native-client";
import { PantryVirtualData, PantryVirtualInfo, PantryVirtualDataInfo, PantryVirtualLineInfo, SEARCH_VIEW_SMALL_HEIGHT_RAITO } from "@/types/pantry";
import PantryVirtualListLineView from "./PantryVirtualListLineView.vue";
import PantryVirtualEmptyView from "@/components/pantry/PantryVirtualEmptyView.vue";
import PantryPullToRefresh from "@/components/common/PantryPullToRefresh.vue";
export default defineComponent({
  name: "PantryVirtualView",
  components: {
    PantryVirtualListLineView,
    PantryVirtualEmptyView,
    PantryPullToRefresh
  },
  props: {
    list: {
      type: Array as PropType<PantryVirtualData[]>,
      default: () => []
    },
    selectMode: {
      type: Boolean,
      default: false,
      required: true
    },
    isShow: {
      type: Boolean,
      default: true,
      required: true
    },
    isRefreshEnabled: {
      type: Boolean,
      default: true,
      require: true
    },
    searchMode: {
      type: Boolean,
      default: false,
      required: true
    }
  },
  setup(props, context: SetupContext) {
    interface HTMLElementEvent<T extends HTMLElement> extends Event {
      target: T;
    }
    const virtualList = ref(new PantryVirtualInfo());
    NativeClient.setTitle(new TitleInfo(false, ""));

    const init = () => {
      for (let i = 0; i < 30; i++) {
        const item = new PantryVirtualData(require("@/assets/images/food_corn.png"), null);
        virtualList.value.list.push(item);
      }
    };
    init();
    // const getVirticalLineList = () => {
    //   const list = Array<PantryVirtualLineInfo>();
    //   let i = 0; // 全データの位置
    //   let lineCount = 0; // １行分のデータ数の判定用
    //   let listMaxCount = 3;  // 1行分の表示データ数
    //   let listCount = 0; // 1行分のデータの位置
    //   let lineInfo = Array<PantryVirtualDataInfo>();
    //   for (const data of virtualList.value.list) {
    //     lineInfo.push(new PantryVirtualDataInfo(i, data));
    //     NativeClient.sendDebugLog("getVirticalLineList i=" + i + " listCount=" + listCount);
    //     if (listCount == listMaxCount - 1) {
    //       list.push(new PantryVirtualLineInfo(lineCount, (listMaxCount == 3), lineInfo));
    //       lineInfo = Array<PantryVirtualDataInfo>();
    //       lineCount++;
    //       listMaxCount = (listMaxCount == 3) ? 2 : 3;
    //       listCount = 0;
    //     } else {
    //       listCount++;
    //     }
    //       i++;
    //   }
    //   if (lineInfo.length != 0) {
    //     list.push(new PantryVirtualLineInfo(lineCount, (listMaxCount == 3), lineInfo));
    //   }
    //   return list;
    // };
    const getVirticalLineList = () => {
      const list = Array<PantryVirtualLineInfo>();
      if (props.list == null) {
        return list;
      }
      let i = 0; // 全データの位置
      let lineCount = 0; // １行分のデータ数の判定用
      let listMaxCount = 3;  // 1行分の表示データ数
      let listCount = 0; // 1行分のデータの位置
      let lineInfo = Array<PantryVirtualDataInfo>();
      for (const data of props.list) {
        lineInfo.push(new PantryVirtualDataInfo(i, data, 0));
        // NativeClient.sendDebugLog("getVirticalLineList i=" + i + " listCount=" + listCount);
        if (listCount == listMaxCount - 1) {
          list.push(new PantryVirtualLineInfo(lineCount, (listMaxCount == 3), lineInfo));
          lineInfo = Array<PantryVirtualDataInfo>();
          lineCount++;
          listMaxCount = (listMaxCount == 3) ? 2 : 3;
          listCount = 0;
        } else {
          listCount++;
        }
          i++;
      }
      if (lineInfo.length != 0) {
        list.push(new PantryVirtualLineInfo(lineCount, (listMaxCount == 3), lineInfo));
      }
      return list;
    };
    const onSelectCheck = (data: PantryVirtualData, checked: boolean) => {
      context.emit("select-check", data, checked);
    };
    const refresh = () => {
      NativeClient.sendDebugLog("PantryVirtualView refresh");
      context.emit("refresh");
    };
    const styleSearchModeView = computed(() => {
      const height = window.innerHeight * SEARCH_VIEW_SMALL_HEIGHT_RAITO;
      return { 'height': height + "px" };
    });
    /**
     * スクロール時イベント
     */
    const onScroll = (e: HTMLElementEvent<HTMLDivElement>) => {
      // NativeClient.sendDebugLog(
      //   "PantryVirtualView onScroll top=" +
      //     e.target.scrollTop +
      //     " height=" +
      //     e.target.offsetHeight +
      //     " total=" +
      //     (e.target.scrollTop + e.target.offsetHeight) +
      //     " scrollH=" +
      //     e.target.scrollHeight
      // );
      // データ初期化後のscrollTop=0では読み込まないようにする
      if (
        e.target.scrollTop != 0 &&
        e.target.scrollTop + e.target.offsetHeight >=
        e.target.scrollHeight - 1
      ) {
        NativeClient.sendDebugLog("PantryVirtualView scrollEnd");
        context.emit("scroll-end");
      }
    };
    return {
      getVirticalLineList,
      onSelectCheck,
      refresh,
      styleSearchModeView,
      onScroll
    };
  }
});
